import { render, staticRenderFns } from "./CampaignDataDetailsView.vue?vue&type=template&id=63dbdaa8"
import script from "./CampaignDataDetailsView.vue?vue&type=script&lang=js"
export * from "./CampaignDataDetailsView.vue?vue&type=script&lang=js"
import style0 from "./CampaignDataDetailsView.vue?vue&type=style&index=0&id=63dbdaa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports